<template>
  <!--
    一覧などの呼び出し元へ戻る導線。表示形式 (「＜ 遷移先名」/「戻る」/アイコンのみ) は
    アプリ全体で統一したいので、このコンポーネントだけを直せば全画面に反映される。
  -->
  <v-btn text small color="primary" class="back-link px-1" :to="to" :exact="exact">
    <v-icon small left class="mr-1">mdi-chevron-left</v-icon>
    <span>{{ label }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'BackLinkComponent',
  props: {
    // 戻り先のルート ({ name: 'FieldListAsList' } など)
    to: {
      type: [Object, String],
      required: true,
    },
    // 戻り先の名称。省略時は汎用の「戻る」
    label: {
      type: String,
      default() {
        return this.$tt('customBack')
      },
    },
    exact: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.back-link {
  min-width: 0;
}
</style>
